import { create } from "zustand";

export interface ModalStore {
  modals: { [key: string]: boolean };
  openModal: (id: string) => void;
  closeModal: (id: string) => void;
}

export const useModalStore = create<ModalStore>((set) => ({
  // State
  modals: {},

  // Actions
  openModal: (id: string) => {
    set((state) => ({
      modals: { ...state.modals, [id]: true },
    }));
  },

  closeModal: (id: string) => {
    set((state) => ({
      modals: { ...state.modals, [id]: false },
    }));
  },
}));
